import axios from "axios";
import {auths, userAuth} from "../client";

export const login = (params) => {
  return auths.post("/token", { ...params });
};

export const signup = (params) => {
  return userAuth.post("/auth/signup", { ...params });
};

export const refresh_token = (params) => {
  return auths.post("/refresh-token", {
    refreshToken: params,
  });
};

export const reset = (params) => {
  return auths.post("/reset-password", {
    email: params.email,
  });
};

export const forgot = (params) => {
  return auths.post("/forgot-password", params);
};

export const verify = (params) => {
  return userAuth.post("/auth/verify-email", params);
};

export const update = (params) => {
  if (params?.code) {
    return userAuth.post("/auth/update-password", {
      email: params.email,
      code: params.code,
      password: params.password,
      confirm: params.confirm,
    });
  }
  return auths.post("/update-password", {
    email: params.email,
    code: params.code,
    password: params.password,
    confirm: params.confirm,
  });
};

export const getAccessContext = (accessToken) => {
  const headers = {};

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return axios.get("/dashboard-api/me/access", {
    headers,
  });
};

export const resolveAccessContext = async (accessToken) => {
  const response = await getAccessContext(accessToken);
  return parseAccessContextResponse(response);
};

export const parseAccessContextResponse = (response) => {
  const data = response?.data;

  if (typeof data?.statusCodeValue === "number") {
    if (data.statusCodeValue >= 400) {
      const error = new Error(
        data.body?.error || data.body || "Unable to resolve access"
      );
      error.statusCode = data.statusCodeValue;
      error.body = data.body || null;
      throw error;
    }
    return data.body || null;
  }

  if (data && typeof data === "object") {
    return data;
  }

  return null;
};
